import React, { useEffect, useState } from "react";

export default function BusinessLoanBenefits() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const items = [
    {
      title: "Expand Your Business",
      iconSrc: "/assets/img/businessloanicons (1).png",
      alt: "Expand Business Icon",
      desc: "Open new branches, buy equipment, or increase production capacity.",
      iconWidth: 30,
      iconHeight: 31,
    },
    {
      title: "Seize Growth Opportunities",
      iconSrc: "/assets/img/businessloanicons (6).png",
      alt: "Growth Opportunities Icon",
      desc: "Invest in marketing, new projects, or product development.",
      iconWidth: 28,
      iconHeight: 38,
    },
    {
      title: "Consolidate Debt",
      iconSrc: "/assets/img/businessloanicons (5).png",
      alt: "Consolidate Debt Icon",
      desc: "Pay off high-interest liabilities and improve financial efficiency.",
      iconWidth: 38,
      iconHeight: 38,
    },
    {
      title: "Manage Cash Flow",
      iconSrc: "/assets/img/businessloanicons (4).png",
      alt: "Cash Flow Icon",
      desc: "Bridge short-term financial gaps without disrupting daily operations.",
      iconWidth: 38,
      iconHeight: 38,
    },
    {
      title: "Hire & Train Talent",
      iconSrc: "/assets/img/businessloanicons (3).png",
      alt: "Hire Talent Icon",
      desc: "Scale up your workforce to meet growing demand.",
      iconWidth: 38,
      iconHeight: 34,
    },
    {
      title: "Build Business Credit",
      iconSrc: "/assets/img/businessloanicons (2).png",
      alt: "Business Credit Icon",
      desc: "A well-managed loan improves your creditworthiness for future financing.",
      iconWidth: 34,
      iconHeight: 31,
    },
  ];

  return (
    <section className="relative p-4 sm:p-8 lg:p-12 max-w-7xl mx-auto z-[0]">
      {/* Background Pattern */}
      <div className="hidden sm:block absolute bottom-[-10%] left-[-15%] sm:left-[-18%] w-screen h-[50vh] dotted-bg z-[-1]"></div>

      {/* Mobile Heading */}
      <div
        className="bg-[#FFFFFF] px-4 xs:px-3 py-12 xs:py-8  rounded-3xl shadow-md w-full sm:hidden"
        style={{ boxShadow: "0 0 100px 50px #F7F1EB" }}
      >
        <h2 className="text-4xl xs:text-[28px] font-atkinson mb-2 text-black">
          Why Consider a{" "} <br/>
          <span className=" relative px-2 italic  font-pp-hatton z-[0]">
            <img src="/assets/img/papertorn.png" loading="lazy" className="-z-10 absolute -top-2 left-0 h-[50px] w-full" />
            Business Loan?
          </span>
        </h2>
        <p className="text-[#000000] mb-4 mt-3 font-atkinson text-lg xs:text-[16px] leading-[1.1] max-w-3xl">
          A business loan isn’t just about borrowing money; it’s about unlocking new possibilities for growth. Here’s why a business loan makes sense:
        </p>
      </div>
      {/* bg-[#12F280] */}
      {/* Desktop Heading */}
      <h2 className="hidden sm:block text-4xl sm:text-3xl md:text-6xl  font-atkinson mb-2 text-black">
        Why Consider a{" "}
        <span className=" relative px-2 italic  font-pp-hatton z-[0]">
          <img src="/assets/img/papertorn.png" loading="lazy" className="-z-10 absolute -top-2 left-0 h-[80px] w-full" />
          Business Loan?
        </span>
      </h2>
      <p className="hidden sm:block text-[#000000] mb-4 sm:mb-6 mt-3 font-atkinson text-lg leading-[1.1] max-w-3xl">
        A business loan isn’t just about borrowing money; it’s about unlocking new possibilities for growth. Here’s why a business loan makes sense:
      </p>

      {/* Desktop Cards */}
      <div className="hidden sm:grid grid-cols-1 sm:mt-5 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {items.map(({ title, iconSrc, alt, desc, iconWidth, iconHeight }, i) => (
          <div key={i} className="p-2 sm:p-0 flex flex-col items-start font-atkinson gap-1 sm:gap-4">
            <div className="flex justify-start items-center gap-3 w-full">
              <img
                src={iconSrc}
                alt={alt}
                width={iconWidth}
                height={iconHeight}
                className="mt-1 shrink-0"
              />
              <h3 className="block sm:hidden text-2xl xs:text-xl max-w-[65%] leading-[1] text-black">{title}</h3>
            </div>
            <div>
              <h3 className="hidden sm:block text-lg text-black">{title}</h3>
              <p className="text-md text-gray-600 mt-1 w-full sm:max-w-[70%] sm:text-sm xs:text-[15px] leading-[1.1]">{desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Cards */}
      <div className="sm:hidden flex flex-col gap-1">
        {items.map(({ title, iconSrc, alt, desc, iconWidth, iconHeight }, i) => (
          <div
            key={i}
            className="p-4 rounded-3xl mt-2 bg-gradient-to-b  shadow-sm from-[#f7f1eb]/10 min-h-[150px] via-[#fffbf7] to-white  flex flex-col items-start font-atkinson gap-1 "

          >
            <div className="flex justify-start items-center gap-3 w-full">
              <img
                src={iconSrc}
                alt={alt}
                width={isMobile ? iconWidth  : iconWidth+2}
                height={isMobile ? iconHeight : iconHeight+2}
                className="mt-1 shrink-0"
              />
              <h3 className="text-2xl xs:text-lg max-w-[65%] leading-[1] xs:leading-5 text-black">{title}</h3>
            </div>
            <p className="text-md xs:text-sm text-gray-600 mt-1 w-full text-[15px] leading-[1.1]">
              {desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
